import { Image, type ImageContentPosition } from "expo-image";
import type { ReactNode } from "react";
import { Pressable, type StyleProp, type ViewStyle } from "react-native";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import type { Logo } from "../types";
import { type LogoVariant, resolveAppLogoSource } from "./helpers";

type Props = {
	logo: Logo;
	variant?: LogoVariant;
	containerStyle: StyleProp<ViewStyle>;
	contentPosition?: ImageContentPosition;
	onPress?: () => void;
	accessibilityLabel?: string;
	inverse?: boolean;
	transition?: number;
};

export const AppLogo = ({
	logo,
	variant = "default",
	containerStyle,
	contentPosition = "left",
	onPress,
	accessibilityLabel = "App Logo",
	inverse = false,
	transition,
}: Props) => {
	const theme = useAppTheme();
	const source = resolveAppLogoSource(logo, variant, theme.dark, inverse);

	const image: ReactNode = (
		<Box style={containerStyle}>
			<Image
				source={source}
				contentFit="contain"
				contentPosition={contentPosition}
				style={{ width: "100%", height: "100%" }}
				transition={transition}
				alt={accessibilityLabel}
				accessibilityLabel={accessibilityLabel}
			/>
		</Box>
	);

	if (!onPress) {
		return image;
	}

	return (
		<Pressable
			onPress={onPress}
			accessibilityRole="link"
			accessibilityLabel={accessibilityLabel}
		>
			{image}
		</Pressable>
	);
};
